import { useFocusEffect } from "expo-router"
import { useCallback, useRef } from "react"

/*
  Use this to run the onFocus callback when the screen refocuses,
  but not on the initial focus when the hook mounts.
*/
export const useOnRefocusEffect = (
  onFocus: () => void,
  deps: React.DependencyList = []
) => {
  const firstTimeRef = useRef(true)

  const onFocusCallback = useCallback(onFocus, deps)

  useFocusEffect(
    useCallback(() => {
      //   This avoids calling onFocus the first time it mounts.
      if (firstTimeRef.current) {
        firstTimeRef.current = false
        return
      }
      onFocusCallback()
    }, [onFocusCallback])
  )
}
